import { Component } from 'react'
import { connect } from 'react-redux'

import { backgroundStyle } from '@adalo/constants'
import { getDatasource } from 'ducks/apps/datasources'

import { EditorObject } from 'utils/responsiveTypes'

import Section from './Section'
import { parseTableFields } from '../Inspect/Libraries/Table/utils'

export type TableField = {
  fieldId: string
  type: string
  label: string
}

type Props = {
  fields: TableField[]
  transparent: string
  orderedFields: string[]
  xScaled: number
  yScaled: number
}

type OwnProps = {
  object: EditorObject & {
    fields: Record<string, { name: string; type: string }>
  }
}

// eslint-disable-next-line react/prefer-stateless-function
class Table extends Component {
  override render(): JSX.Element {
    const { fields, transparent, xScaled, yScaled } = this.props as Props

    return (
      <Section
        {...this.props}
        hideShadows={transparent}
        backgroundStyle="color"
        backgroundColor="#e0e0e0"
      >
        <svg width="100%" height="100%">
          {fields &&
            fields.map((field, index) => (
              <text
                key={field.fieldId}
                x={xScaled}
                y={20 + yScaled + index * 20}
                fontFamily="Arial"
                fontSize="14"
                fill="black"
              >
                {`Field: ${field.fieldId}
                  Name:  ${field.label}
                  Type: ${field.type}
                `}
              </text>
            ))}
        </svg>
      </Section>
    )
  }
}

const mapStateToProps = (
  state: Record<string, unknown>,
  { object }: OwnProps
) => {
  const transparent = object?.backgroundStyle === backgroundStyle.NONE

  const { fields } = object

  if (Array.isArray(fields) && fields.length > 0) {
    return { fields, transparent }
  }

  let initialFields

  if (fields && !Array.isArray(fields)) {
    initialFields = parseTableFields(fields)
  }

  return {
    fields: initialFields,
    transparent,
  }
}

export default connect(mapStateToProps, { getDatasource })(Table)
